module.exports = __webpack_public_path__ + "static/media/6-4.1685b1aa.mp3";